import { useQuery } from "@tanstack/react-query"

import { AdminRequests, AdminResponses } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"

export const useGetBouncedEmails = ({
  fetchDataOptions,
  filters,
}: AdminRequests.findBouncedEmailsRequest) => {
  return useQuery(["bouncedEmails", fetchDataOptions, filters], async () => {
    const response =
      await httpClient.get<AdminResponses.FindAllBouncedEmailsResponseDto>(
        "/admin/traceability/find-all-bounced-emails",
        {
          params: {
            fetchDataOptions,
            filters,
          },
        }
      )
    return response.data
  })
}
